import React from 'react';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { Button } from 'react-bootstrap';

const ExportExcel = (props) => {
    const fileType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8`;
    const fileExtension = '.xlsx';

    const exportToExcel = async () => {
        const ws = XLSX.utils.json_to_sheet(props.excelData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, props.fileName + fileExtension);
    };

    return (
        <Button
            variant='btn'
            style={{ backgroundColor: 'green', fontFamily: 'Poppins-Regular', color: 'white' }}
            onClick={(e) => exportToExcel(props.fileName)}
        >
            Excel
        </Button>
    );
};

export default ExportExcel
